import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import home from './modules/home'
import resources from './modules/resources'
import navigation from './modules/navigation'
import course from './modules/course'
import outline from './modules/outline'
import { SAAS_USER_INFO } from '../util/keys'

Vue.use(Vuex)
export default new Vuex.Store({
    getters,
    modules: {
        home,
        resources,
        course,
        outline,
        navigation
    },
    state: {
        // 当前登陆者用户信息
        userInfo: JSON.parse(localStorage.getItem(SAAS_USER_INFO)) || {
            user: {}
        }
    },
    strict: false
})



// WEBPACK FOOTER //
// ./src/js/store/index.js